import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tooltip', 'button']
  static values = {text: String, copiedText: String}

  copy() {
    navigator.clipboard.writeText(this.textValue).catch(() => {})
    this.hasButtonTarget ? this.#showButtonFeedback() : this.#showTooltipFeedback()
  }

  disconnect() {
    clearTimeout(this.hideTimeout)
  }

  #showButtonFeedback() {
    const btn = this.buttonTarget
    if (btn.textContent.trim() !== this.copiedTextValue) {
      this._originalText = btn.textContent.trim()
    }
    clearTimeout(this.hideTimeout)
    btn.textContent = this.copiedTextValue
    this.hideTimeout = setTimeout(() => { btn.textContent = this._originalText }, 2000)
  }

  #showTooltipFeedback() {
    const tooltip = window.bootstrap.Tooltip.getOrCreateInstance(this.tooltipTarget)
    tooltip.show()
    this.hideTimeout = setTimeout(() => tooltip.hide(), 2000)
  }
}
